<script lang="ts">
	import { snackbar } from '$lib/stores/index.js';
	import { t } from 'svelte-i18n';
	import { urls } from '@app/urls.js';
	import { page } from '$app/stores';
	import { canHaveGhostAccess } from '@app/utils/user.js';
	import ButtonTextPrimary from '$lib/elements/buttons/variants/ButtonTextPrimary.svelte';
	import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import { APIEndpoints } from '@app/enums/APIEndpoints';
	import { invalidateAll } from '$app/navigation';
	import { datadogRum } from '@datadog/browser-rum';
	import { error } from '@sveltejs/kit';

	const logout = async () => {
		const res = await fetch(APIEndpoints.SIGN_OUT, { method: 'POST' });
		if (res.ok) {
			await invalidateAll();
			datadogRum.removeGlobalContextProperty('userId');
		} else {
			const json = await res.json();
			snackbar.danger(json.body?.message ?? $t('logoutError'));
			throw error(json.status, json.body);
		}
	};
</script>

<ul class="flex flex-col space-y-3">
	<li>
		<ButtonText
			props={{
				label: $t('userNav.dashboard'),
				href: urls.USER.DASHBOARD,
				iconLeft: 'home',
				iconSize: 'default',
				classNames: $page.url.pathname === urls.USER.DASHBOARD ? 'text-primary font-medium' : ''
			}}
			on:click={() => ($isSidebarOpen = false)}
		/>
	</li>
	<li>
		<ButtonText
			props={{
				label: $t('userNav.wallet'),
				href: urls.USER.WALLET.INDEX,
				iconLeft: 'wallet',
				iconSize: 'default',
				classNames: $page.url.pathname.startsWith(urls.USER.WALLET.PATH)
					? 'text-primary font-medium'
					: ''
			}}
			on:click={() => ($isSidebarOpen = false)}
		/>
	</li>
	<li>
		<ButtonText
			props={{
				label: $t('userNav.profile'),
				href: urls.USER.ACCOUNT.INDEX,
				iconLeft: 'account',
				iconSize: 'default',
				classNames:
					$page.url.pathname.startsWith(urls.USER.ACCOUNT.INDEX) &&
					!$page.url.pathname.startsWith(urls.USER.WALLET.PATH)
						? 'text-primary font-medium'
						: ''
			}}
			on:click={() => ($isSidebarOpen = false)}
		/>
	</li>
	<li>
		<ButtonText
			props={{
				label: $t('userNav.newsfeed'),
				href: urls.NEWS_FEED,
				iconLeft: 'newspaper',
				iconSize: 'default',
				classNames: $page.url.pathname === urls.NEWS_FEED ? 'text-primary font-medium' : ''
			}}
			on:click={() => ($isSidebarOpen = false)}
		/>
	</li>

	<li>
		<ButtonText
			props={{
				label: $t('userNav.taxation'),
				href: urls.USER.TAXATION.INDEX,
				iconLeft: 'calculate',
				iconSize: 'default',
				classNames: $page.url.pathname.startsWith(urls.USER.TAXATION.INDEX)
					? 'text-primary font-medium'
					: ''
			}}
			on:click={() => ($isSidebarOpen = false)}
		/>
	</li>

	{#if $page.data?.user?.accesEspaces}
		{#each $page.data?.user?.accesEspaces as userSpace}
			<li>
				<ButtonText
					props={{
						label: userSpace.label,
						href: userSpace.url,
						hrefTarget: 'blank',
						iconLeft: 'work'
					}}
					on:click={() => ($isSidebarOpen = false)}
				/>
			</li>
		{/each}
	{/if}

	{#if canHaveGhostAccess($page.data?.user)}
		<li>
			<ButtonText
				props={{
					label: $t('ghost.nav'),
					href: urls.USER.GHOST_LOGIN,
					iconLeft: 'build'
				}}
				on:click={() => ($isSidebarOpen = false)}
			/>
		</li>
	{/if}

	<li>
		<ButtonText
			props={{
				label: $t('logout'),
				iconLeft: 'log-out'
			}}
			on:click={() => {
				$isSidebarOpen = false;
				logout();
			}}
		/>
	</li>
</ul>
